export const PHOENIX_AUTH_BROADCAST_CHANNEL = 'phoenix-auth';

export const PHOENIX_CROSS_TAB_LOGOUT_TYPE = 'PHOENIX_CROSS_TAB_LOGOUT';
